/* eslint-disable @typescript-eslint/dot-notation */
import { Injectable } from '@angular/core'
import { CptSharedDataService } from '@inside-hub-app/customer-portal-shared'
import { BehaviorSubject, Observable } from 'rxjs'
import { filter } from 'rxjs/operators'
import { type KcActivationFinishViewData, type KcChooseExistingViewData, type KcClientData, type KcCompanyFinishViewData, type KcCompanyRequestChangeViewData, type KcConsentsViewData, type KcData, type KcEnterTelephoneViewData, type KcInfoData, type KcLocaleData, type KcLoginViewData, type KcMessage, type KcPersonalizeNewViewData, type KcPersonalizeViewData, type KcRealmData, type KcRegisterBusinessInviteFinishViewData, type KcRegisterBusinessInviteViewData, type KcRegisterFinishViewData, type KcRegisterViewData, type KcRequestBusinessInvite, type KcResetPasswordViewData, type KcSamlPostData, type KcSetPasswordViewData, type KcTelephoneValidationViewData, type KcUpdatePasswordViewData } from './interfaces/kc-data.interface'
import { HttpClient } from '@angular/common/http'

@Injectable({
  providedIn: 'root'
})
export class KcDataService {
  private data: KcData

  private readonly _kcData = new BehaviorSubject<KcData>(null)
  onKcDataLoaded = this._kcData.asObservable().pipe(filter(this.isNonNull))

  // Don't emit null values from Observables
  isNonNull<T>(value: T): value is NonNullable<T> {
    return value != null
  }

  constructor (
    private readonly sharedData: CptSharedDataService,
    private readonly http: HttpClient
  ) {
    this.setData()
  }

  public setData () {
    if (window['ef']?.['kc']?.['data']) {
      this.data = window['ef']['kc']['data']
      this.data.title = this.data.title.trim()

      this.sharedData.setResourcesPath(this.getResourcesPath())
      this._kcData.next(this.data)
    }
  }

  public getData () {
    return this.data
  }

  public getTitle (): string {
    return this.data?.title
  }

  public getView (): string {
    return this.data?.view
  }

  public getGlobalTranslation (key: string): string {
    if (this.data?.globalTranslations[key] === undefined) {
      return key
    }

    return this.data?.globalTranslations[key]
  }

  public getTranslation (key: string): string {
    if (this.data?.translations[key] === undefined) {
      return key
    }

    return this.data?.translations[key]
  }

  public getViewData ():
  | KcLoginViewData
  | KcMessage
  | KcInfoData
  | KcRegisterViewData
  | KcRequestBusinessInvite
  | KcCompanyRequestChangeViewData
  | KcCompanyFinishViewData
  | KcPersonalizeViewData
  | KcPersonalizeNewViewData
  | KcChooseExistingViewData
  | KcEnterTelephoneViewData
  | KcTelephoneValidationViewData
  | KcRegisterFinishViewData
  | KcResetPasswordViewData
  | KcUpdatePasswordViewData
  | KcSetPasswordViewData
  | KcConsentsViewData
  | KcActivationFinishViewData
  | KcRegisterBusinessInviteViewData
  | KcRegisterBusinessInviteFinishViewData
  | KcSamlPostData {
    return this.data?.viewData
  }

  public getRealmData (): KcRealmData {
    return this.data?.realmData
  }

  public getClientData (): KcClientData {
    return this.data?.clientData
  }

  public getLocaleData (): KcLocaleData {
    if (!this.data) {
      this.setData()
    }
    return this.data?.localeData
  }

  public getResourcesPath (): string {
    return this.data?.resourcesPath
  }

  public getMessage (): KcMessage {
    return this.data?.message
  }

  public setMessage (message: KcMessage): void {
    this.data.message = message
  }

  public postSamlData (data: KcSamlPostData): Observable<any> {
    const kcUrl = data.url
    const fd = new FormData()
    fd.append('SAMLResponse', data.samlResponse)
    fd.append('RelayState', data.relayState)
    const request = this.http.post(kcUrl, fd)
    return request
  }
}
